import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OhayoUtilModule } from '@ohayojp/util';

@NgModule({
  imports: [CommonModule, OhayoUtilModule],
})
export class ZipModule { }
